import * as React from 'react';
import Box from '@mui/material/Box';
import MuiModal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { IconButton, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ModalProps } from 'types/modal';

const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: 'calc(100% - 32px)', sm: 'min(520px, 90vw)' },
    maxWidth: 560,
    maxHeight: 'calc(100vh - 32px)',
    overflowY: 'auto',
    borderRadius: 2,
    bgcolor: 'background.paper',
    boxShadow: 24,
};

const Modal = ({ isOpen, modalTitle, children, onClose, contentAlign = 'center' }: ModalProps) => {
    return (
        <MuiModal
            keepMounted
            open={isOpen}
            onClose={onClose}
            aria-labelledby="confirm-modal-title"
            aria-describedby="confirm-modal-description"
        >
            <Box sx={style}>
                <Stack width="100%" p={{ xs: 2, sm: 3 }} sx={{ position: 'relative' }}>
                    <IconButton
                        onClick={onClose}
                        sx={{ position: 'absolute', top: 5, right: 5, zIndex: (theme) => theme.zIndex.modal + 1 }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography
                        sx={{ textAlign: 'center', fontWeight: 600, fontSize: { xs: 16, sm: 22 }, pr: 4 }}
                        id="confirm-modal-title"
                        variant="h6"
                        component="h1"
                        textTransform="capitalize"
                    >
                        {modalTitle}
                    </Typography>
                    {children && (
                        <Box id="confirm-modal-description" sx={{ mt: 1.5, textAlign: contentAlign, width: '100%' }}>
                            {children}
                        </Box>
                    )}
                </Stack>
            </Box>
        </MuiModal>
    );
};

export default Modal;
